module.exports = __webpack_public_path__ + "img/39.2c198cea.jpg";